/* eslint-disable @typescript-eslint/no-explicit-any */
export function isResponseError(t: any): t is Response {
  if (t.type != null && t.url != null && t.headers != null && t.status != null) {
    if (t.status < 200 || t.status >= 300) {
      return true
    }
  }
  return false
}
